import { Box, Container, Grid, Typography, Divider, useTheme, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import { PAGES } from "../../constants";

interface AboutOurDataProps {
  componentLocation: "splash" | string;
}
const BorderedContent = styled(Box)(({ theme }) => ({
    borderTop: `4px solid ${theme.palette.primary.main}`,
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
}));

const AboutOurData: React.FC<AboutOurDataProps> = ({ componentLocation }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isDashboard = componentLocation === 'dashboard';

  // Main content
  const content = (
    <>
      <Typography variant="h5" sx={{ mb: 1 }} color="white">
        About our Data
      </Typography>
      {isXs && (
        <BorderedContent />
      )}
      <Typography variant="body1" color="white">
        { PAGES['splash'].contents.aboutOurDataText }
      </Typography>
    </>
  );

  const bgColor = componentLocation === "splash" ? theme.custom.navy : theme.palette.primary.main;

  return (
    <Box
      sx={{
        ...(isDashboard
          ? {
              // For dashboard: use 100% width to avoid overflow with drawer margin
              width: '100%',
              position: 'relative',
            }
          : {
              // For splash: use full bleed technique
              width: '100vw',
              position: 'relative',
              left: '50%',
              right: '50%',
              marginLeft: '-50vw',
              marginRight: '-50vw',
            }),
        marginRight: '-50vw',
        backgroundColor: bgColor,
        py: 3, // vertical padding
      }}
    >
      <Container maxWidth={isDashboard ? false : "lg"} sx={{ zIndex: 1}} disableGutters={isDashboard}>
        <Grid container>
          <Grid size ={{xs: 12 , lg: isDashboard ? 12 : 9}} sx={{ mx: isDashboard ? 2 : 0}}>
            {content}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutOurData;